import { theme } from "@tm/utility/global";
import styled from "styled-components";

export const PageContainer = styled.div`
  min-height: 100vh;
  background: #f2f2f2;
`;

export const Hero = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;
  background: ${theme.whiteText};
`;

export const HeroTitleBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 10px 16px 9px;
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;

  &::before {
    content: "";
    display: block;
    width: 10px;
    height: 10px;
    border-left: 2px solid ${theme.blackText};
    border-bottom: 2px solid ${theme.blackText};
    transform: rotate(45deg);
    margin-left: 4px;
  }
`;

export const HeroTitle = styled.h1`
  margin: 0;
  font-size: 16px;
  line-height: 20px;
  font-weight: 700;
  color: ${theme.blackText};
  flex: 1;
`;

export const PromoStrip = styled.div`
  width: 100%;
  padding: 8px 16px;
  font-size: 12px;
  line-height: 16px;
  color: ${theme.greyText};
  text-align: center;
  background: linear-gradient(
    90deg,
    #ffffff 0%,
    #fceeff 10.5%,
    #fceeff 88.5%,
    #ffffff 100%
  );
  box-sizing: border-box;
`;

export const HeroSubTitle = styled.p`
  margin: 4px 0 0;
  font-size: 12px;
  line-height: 16px;
  color: ${theme.greyText6};
`;

export const Content = styled.div`
  max-width: 480px;
  margin: 0 auto;
  padding: 0 0 80px;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
`;

/**
 * RN `headingPersuasionWrapper`: white band under hero (not on gray page bg).
 */
export const HeadingPersuasionWrapper = styled.div`
  width: 100%;
  background: ${theme.whiteText};
  display: flex;
  justify-content: center;
  padding: 0 16px 8px;
  box-sizing: border-box;
`;

/**
 * RN `contentWrapperShadow` — clips shadow and pulls form panel up slightly.
 */
export const FormPanelShadow = styled.div<{ $pullUp?: boolean }>`
  overflow: hidden;
  margin-top: 0;
  margin-bottom: 0;
  padding-bottom: 8px;
  width: 100%;
  box-sizing: border-box;
`;

/**
 * RN `contentWrapper`: full-bleed white sheet, horizontal padding 16, bottom border + shadow.
 */
export const WhiteCard = styled.div`
  background: ${theme.whiteText};
  width: 100%;
  margin: 0;
  padding: 8px 16px 16px;
  box-sizing: border-box;
  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.12);
  border-radius: 0;
`;

export const MainContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding-top: 32px;
  width: 100%;
  min-width: 0;

  & > * {
    min-width: 0;
  }
`;

export const StickyPanel = styled.div<{ $show: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 20;
  background: #f2f2f2;
  border-bottom: 1px solid #e8edf7;
  box-shadow: 0 4px 16px rgba(22, 40, 74, 0.08);
  padding: env(safe-area-inset-top, 0px) 0 12px;
  box-sizing: border-box;
  transform: translateY(${({ $show }) => ($show ? "0" : "-100%")});
  transition: transform 0.22s ease;
  pointer-events: ${({ $show }) => ($show ? "auto" : "none")};
`;

export const StickyHeroBlock = styled.div`
  width: 100%;
  background: ${theme.whiteText};
  box-sizing: border-box;
`;

export const StickyPanelInner = styled.div`
  max-width: 480px;
  margin: 0 auto;
  padding: 12px 16px 0;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
`;

export const Tabs = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 32px;
  border: 1px solid #d8d8d8;
  border-radius: 8px;
  box-sizing: border-box;
`;

export const Tab = styled.button<{ $active: boolean }>`
  appearance: none;
  -webkit-appearance: none;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  border: ${({ $active }) =>
    $active ? `1px solid ${theme.blueText}` : "1px solid transparent"};
  border-radius: 6px;
  background: ${({ $active }) =>
    $active ? theme.lightBlueBg : "transparent"};
  color: ${({ $active }) => ($active ? theme.blueText : theme.greyText)};
  font-family: inherit;
  font-weight: ${({ $active }) => ($active ? 900 : 400)};
  font-size: 12px;
  line-height: 1;
  cursor: pointer;
  text-align: center;
  box-sizing: border-box;
`;

export const FormContentGap = styled.div`
  margin-top: 10px;
`;
